import React from "react";
import ReactDOM from "react-dom";
import Demo from "./demo/Demo";
import registerServiceWorker from "./registerServiceWorker";

ReactDOM.render(
    <Demo />, 
    document.getElementById("root")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js